import { useEffect, useRef } from 'react';

const profiles = [
  {
    icon: 'ri-vip-crown-line',
    title: 'CEOs e Fundadoras',
    desc: 'Tomadoras de decisão com pele no jogo.',
  },
  {
    icon: 'ri-building-4-line',
    title: 'C-Level e Diretoras',
    desc: 'VPs, CFOs, COOs, CMOs. Mulheres que movem a engrenagem.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Empreendedoras em Escala',
    desc: 'Startups, franqueadoras, investidoras-anjo.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Profissionais Liberais',
    desc: 'Arquitetas, advogadas, médicas, engenheiras empresárias.',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Líderes de Influência',
    desc: 'Voz ativa em seus setores, dentro e fora das redes.',
  },
];

export default function ForWhomSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.animate-target').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="para-quem"
      ref={sectionRef}
      className="bg-cream py-28 md:py-36 px-6 relative overflow-hidden"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left: Content */}
          <div>
            <div className="animate-target opacity-0 transition-all duration-700 mb-5" style={{ transform: 'translateY(30px)' }}>
              <span className="font-sans text-xs tracking-widest3 uppercase text-gold" style={{ letterSpacing: '0.3em' }}>
                Para Quem
              </span>
              <div className="w-12 h-px bg-gold mt-3" />
            </div>

            <div className="animate-target opacity-0 transition-all duration-700 mb-5" style={{ transform: 'translateY(30px)' }}>
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-obsidian leading-tight">
                Quem são as{' '}
                <span className="italic text-gold">Leoas?</span>
              </h2>
            </div>

            <p className="animate-target opacity-0 transition-all duration-700 font-sans text-sm text-obsidian/60 mb-10 font-light" style={{ transform: 'translateY(30px)' }}>
              Cada cadeira é curada. Cada presença gera valor.
            </p>

            <div className="space-y-6">
              {profiles.map((p, i) => (
                <div
                  key={p.title}
                  className="animate-target opacity-0 transition-all duration-700 flex items-start gap-5 group"
                  style={{ transform: 'translateY(30px)', transitionDelay: `${i * 100}ms` }}
                >
                  <div className="w-10 h-10 flex items-center justify-center border border-gold/40 group-hover:border-gold group-hover:bg-gold/10 transition-all duration-300 flex-shrink-0 mt-0.5">
                    <i className={`${p.icon} text-gold text-lg`} />
                  </div>
                  <div>
                    <h3 className="font-sans text-xs tracking-widest uppercase text-obsidian font-semibold mb-1" style={{ letterSpacing: '0.15em' }}>
                      {p.title}
                    </h3>
                    <p className="font-sans text-sm text-obsidian/60 font-light">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="animate-target opacity-0 transition-all duration-700" style={{ transform: 'translateY(30px)' }}>
            <div className="relative">
              <div className="absolute -bottom-4 -right-4 w-full h-full border border-gold/30 hidden md:block" />
              <div className="w-full h-[340px] md:h-[540px] overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/95ab1d24-f5e3-49af-acf5-f9d2f5689cc7/eee65bed-d3d8-4e06-b08a-1143216bd83e_WhatsApp-Image-2026-04-09-at-12.00.42.jpeg?v=fb276029eedecd38b983253ee2405c30"
                  alt="As Leoas"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              {/* Gold accent block */}
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-gold/10 border border-gold/30 hidden md:block" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
